import { FiltersBar, SearchInput, useFilterUpdate } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

import { useAddressBookListFilter } from './useAddressBookListFilter';

export function Filters() {
  const { search, setSearch } = useAddressBookListFilter();
  const { t } = useTranslation();

  useFilterUpdate('search', search);

  return (
    <FiltersBar.Row>
      <SearchInput
        placeholder={t('addressBook.list.searchPlaceholder')}
        onChange={v => setSearch(v)}
        defaultValue={search}
      />
    </FiltersBar.Row>
  );
}
